"use client";

import { useCallback } from "react";
import { openCalModal } from "./PageWithCalModal";
import NavbarGradientButton from "./NavbarGradientButton";
import type { FinalCtaSectionData } from "@/types/cms";
import { trackCTAClicked, trackMeetingModalOpened } from "@/lib/analytics";
import { useSectionTracking } from "@/lib/analytics/use-section-tracking";

interface FinalCTASectionProps {
  data: FinalCtaSectionData;
}

export default function FinalCTASection({ data }: FinalCTASectionProps) {
  const sectionRef = useSectionTracking("Final CTA Section", "final-cta");
  const handleRequestDemo = useCallback(() => {
    trackCTAClicked({
      cta_location: "final_cta",
      cta_type: "demo",
      cta_text: data.buttonText,
    });
    if (data.buttonLink === "request_demo") {
      trackMeetingModalOpened("final_cta");
      openCalModal("momentumworld/30min");
    }
  }, [data.buttonLink, data.buttonText]);

  return (
    <section
      ref={sectionRef as React.RefObject<HTMLElement>}
      className="relative py-24 px-6 overflow-hidden"
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl text-white mb-4">
          {data.title}
        </h2>
        <p className="text-lg md:text-xl text-white/60 mb-10">
          {data.subtitle}
        </p>
        <NavbarGradientButton
          link={data.buttonLink}
          onClick={handleRequestDemo}
          className="px-10! py-4! text-lg! md:text-xl! font-semibold"
        >
          {data.buttonText}
        </NavbarGradientButton>
      </div>
    </section>
  );
}
